import { utils } from "@alife/cone-arms-core";
import { supportedEntryType } from "./utils";
var checkWin = utils.checkWin;
// 500k以上认为是大文件
var bigFileSizeLimit = 500 * 1024;
export var initResourceObserver = function() {
    if (checkWin() && supportedEntryType("resource")) {
        var allResources = [];
        var useCacheResources = [];
        var bigFiles = [];
        var po = new PerformanceObserver(function(list) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = list.getEntries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    var entry = item;
                    if (entry.name && /\.(js|css)$/.test(entry.name)) {
                        allResources.push(entry.name);
                        if (entry.transferSize === 0 || entry.duration < 50) {
                            useCacheResources.push(entry.name);
                        }
                        // 体积大于500KB或加载耗时超过1秒
                        if (entry.decodedBodySize > bigFileSizeLimit || entry.duration > 1000) {
                            bigFiles.push(entry.name);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        // Start listening for `resource` entries to be dispatched.
        try {
            po.observe({
                type: "resource",
                buffered: true
            });
        } catch (e) {
        // ignore error
        }
        return {
            reset: function() {
                allResources = [];
                useCacheResources = [];
                bigFiles = [];
            },
            getData: function() {
                return {
                    bigFiles: bigFiles,
                    cacheUseRate: allResources.length > 0 && allResources.length >= useCacheResources.length ? (useCacheResources.length / allResources.length).toFixed(3) : 1,
                    jsFiles: allResources.filter(function(name) {
                        return /\.js$/.test(name);
                    })
                };
            },
            unbind: function() {
                po.disconnect();
            }
        };
    }
};

 //# sourceMappingURL=observe-resource-load.js.map